import React, { memo, useState, useEffect, useRef } from 'react';
import { Flex, Carousel } from 'antd-mobile';
import { ImgWrap } from 'pubBiz';

const SliderCell = memo((props) => {
  const [rate, setRate] = useState(23 / 20);
  const [nowPage, setNowPage] = useState(1);
  const dragStateRef = useRef({
    pointerStart: null,
    hasMoved: false,
    preventClickAfterDrag: false,
    preventClickTimer: null
  });
  const {
    containerStyle, // Object 容器样式
    width, // any 容器宽度
    data: dataObj, // Object 数据源
    showBullets = true, // Boolean 是否显示轮播指示器
    onPress // Function 点击事件
  } = props;

  const {
    datas: data = [], // Array 数据
    filletValue = 0 // Number 圆角
  } = dataObj;

  useEffect(() => {
    if (data.length > 0) {
      const { imgInfo } = data[0];
      if (imgInfo && imgInfo.width && imgInfo.height) {
        setRate(imgInfo.width / imgInfo.height);
      } else {
        setRate(23 / 20);
      }
    }
  }, [data]);

  // 记录拖拽起点，给 touch / mouse 共用，避免 PC 下拖拽轮播后又误触发点击跳转。
  const markPointerStart = (pageX, pageY) => {
    dragStateRef.current.pointerStart = { pageX, pageY };
    dragStateRef.current.hasMoved = false;
  };

  // 位移超过阈值就认定为拖拽，后续 click 需要拦截，避免“拖一下就跳链接”。
  const markPointerMove = (pageX, pageY) => {
    const { pointerStart } = dragStateRef.current;
    if (!pointerStart) return;
    const moveX = Math.abs(pageX - pointerStart.pageX);
    const moveY = Math.abs(pageY - pointerStart.pageY);
    if (moveX > 8 || moveY > 8) {
      dragStateRef.current.hasMoved = true;
    }
  };

  // 拖拽结束后的这一个 click 周期内屏蔽点击，避免鼠标松手时被轮播项当成普通点击。
  const markPointerEnd = () => {
    const current = dragStateRef.current;
    current.preventClickAfterDrag = current.hasMoved;
    current.pointerStart = null;
    current.hasMoved = false;
    if (current.preventClickAfterDrag) {
      clearTimeout(current.preventClickTimer);
      current.preventClickTimer = setTimeout(() => {
        dragStateRef.current.preventClickAfterDrag = false;
      }, 120);
    }
  };

  const shouldPreventClick = (e) => {
    if (!dragStateRef.current.preventClickAfterDrag) return false;
    e && e.preventDefault && e.preventDefault();
    e && e.stopPropagation && e.stopPropagation();
    return true;
  };

  // 渲染轮播指示器
  const renderBullet = () => {
    if (!showBullets) return null;

    // banner的张数
    const length = data.length;

    // 指示器总宽度
    const viewW = '1.86rem';
    const nowW = `calc(${viewW} * (${nowPage} / ${length})`;

    return (
      <Flex
        direction="row"
        align="center"
        style={{
          width: viewW,
          height: '0.06rem',
          background: '#f5f7fa'
        }}>
        <Flex
          style={{
            width: nowW,
            height: '0.06rem',
            background: '#040404'
          }}
        />
      </Flex>
    );
  };

  return (
    <Flex
      direction="column"
      align="center"
      style={{
        ...containerStyle,
        borderRadius: `${(filletValue / 100) * 2}rem`
      }}
      onMouseDown={(e) => markPointerStart(e.pageX, e.pageY)}
      onMouseMove={(e) => markPointerMove(e.pageX, e.pageY)}
      onMouseUp={markPointerEnd}
      onMouseLeave={markPointerEnd}>
      <Carousel
        style={{
          width,
          height: `calc(${width} / ${rate})`
        }}
        autoplay
        dragging
        infinite
        dots={false}
        afterChange={(index) => setNowPage(index + 1)}>
        {data.map((item, index) => {
          const { imgInfo } = item;
          const { imgUrl } = imgInfo;

          return (
            <Flex
              key={index}
              onDragStart={(e) => e.preventDefault()}
              onClick={(e) => {
                if (shouldPreventClick(e)) return;
                onPress && onPress(item);
              }}>
              <ImgWrap w={width} h={`calc(${width} / ${rate})`} src={imgUrl} mode="cover" />
            </Flex>
          );
        })}
      </Carousel>
      {renderBullet()}
    </Flex>
  );
});

export default SliderCell;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/SliderCell/index.js